import { createSlice } from "@reduxjs/toolkit";
import axios from "src/utils/axios";

// Slice de patrones de rotación multi-semana (F5).
// Endpoint base: /api/rotationPattern

const initialState = {
  isLoading: false,
  error: null,
  patternByConfig: {},       // { [configId]: DtoRotationPatternGet | null }
  schedulesByConfig: {},     // { [configId]: DtoScheduleForRotation[] }
};

const slice = createSlice({
  name: "rotationPatterns",
  initialState,
  reducers: {
    startLoading(state) { state.isLoading = true; state.error = null; },
    stopLoading(state) { state.isLoading = false; },
    hasError(state, action) { state.isLoading = false; state.error = action.payload; },

    setPattern(state, action) {
      const { configId, pattern } = action.payload;
      state.patternByConfig[configId] = pattern || null;
      state.isLoading = false;
    },
    setSchedules(state, action) {
      const { configId, schedules } = action.payload;
      state.schedulesByConfig[configId] = schedules || [];
    },
    clearPattern(state, action) {
      const { configId } = action.payload;
      state.patternByConfig[configId] = null;
    },
  },
});

export default slice.reducer;
export const { setPattern, setSchedules, clearPattern } = slice.actions;

// ── Thunks ──────────────────────────────────────────────────────────

export function getRotationPattern(configId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const res = await axios.get(`/rotationPattern/byConfig/${configId}`);
      dispatch(slice.actions.setPattern({ configId, pattern: res.data }));
      return res.data;
    } catch (err) {
      dispatch(slice.actions.hasError(err?.message || "Error cargando rotación"));
    }
  };
}

export function getSchedulesForRotation(configId) {
  return async (dispatch) => {
    const res = await axios.get(`/rotationPattern/schedulesForRotation/${configId}`);
    dispatch(slice.actions.setSchedules({ configId, schedules: res.data || [] }));
    return res.data;
  };
}

export function upsertRotationPattern(payload) {
  return async (dispatch) => {
    const res = await axios.post("/rotationPattern/upsert", payload);
    dispatch(slice.actions.setPattern({
      configId: payload.employeeScheduleConfigId,
      pattern: res.data,
    }));
    // Refresca schedules para reflejar assignments actualizadas.
    await dispatch(getSchedulesForRotation(payload.employeeScheduleConfigId));
    return res.data;
  };
}

export function deleteRotationPattern(patternId, configId) {
  return async (dispatch) => {
    await axios.delete(`/rotationPattern/${patternId}`);
    dispatch(slice.actions.clearPattern({ configId }));
    if (configId) await dispatch(getSchedulesForRotation(configId));
  };
}

// 2026-09-14 · Aplicar patrón: regenera los WorkScheduleItem futuros
// según la plantilla + rotación actual. Idempotente, preserva fichajes.
export function applyRotationPattern(configId) {
  return async () => {
    await axios.post(`/rotationPattern/apply/${configId}`);
  };
}
